<template>
  <div id="milestone-carousel-list">
    <!-- Progress Bar appears when there are no milestones in the study -->
    <div v-if="milestonesList == null || showDateRangeView" class="all-milestone-progress-bar">
      <div class="participant-current-day" v-if="displayMobileView === false">
        <div class="text-left float-left pl-10">
          <span v-if="triggerDay.currentDayTextVisiblity">
            <span v-if="isParticipantInActive">Participant was {{ participantStatusInLowerCase }} on</span>
            <template v-if="isParticipantActive && shouldNotShowDayZeroMsg()">
              <span>Participant is on</span>
              <span v-if="studyData.screeningMilestoneAllowed">
                <a href="javascript:void(0)" @click.prevent="onMilestoneChange(customizeMilestone, 0, true)">
                  Day
                  {{ participantData.participantCurrentDay - studyData.screeningDuration }}</a
                >
              </span>
              <span v-else>
                <a href="javascript:void(0)" @click.prevent="onMilestoneChange(customizeMilestone, 0, true)"> Day {{ participantData.participantCurrentDay }}</a>
              </span>
            </template>
            <template v-else-if="isParticipantBeingScreened">
              <span>Participant is currently being screened</span>
            </template>
            <span v-if="isParticipantInActive">
              <b> Day {{ participantData.participantInActiveDay }} </b>
              on
              {{ new Date(participantData.inActiveDate) | dateFormat("MMM DD") }},
              {{ new Date(participantData.inActiveDate) | dateFormat("YYYY") }}
            </span>
            <template v-if="!isParticipantBeingScreened">
              <span class="color-grey pl-10" v-if="triggerDay.triggeredDate">{{ triggerDay.confirmationText }}</span>
              <span class="color-grey" v-if="triggerDay.triggeredDate">{{ new Date(triggerDay.triggeredDate) | formatUTCDate }}</span>
            </template>
          </span>
          <div v-if="triggerDay.triggeredBtnVisiblity" class="pb-25">
            <button class="btn- btn-primary trigger-btn" @click="triggerParticipantDay()">
              Start Study
            </button>
            <span>Click this button to start study activities for this participant.</span>
          </div>
          <div v-if="triggerDay.confirmationText && triggerDay.triggeredDate == null" class="confirmation-text">
            <span v-html="triggerDay.confirmationText" :class="{ 'date-underline': isRescheduleDatePopovershown }"></span>
            <span v-if="triggerDay.editScheduledStartDate" id="popover-edit-scheduled-start-date">
              <img src="/static/img/icon-edit.svg" class="ml-5 icon-edit" style="cursor:pointer; vertical-align: inherit;" />
            </span>
          </div>
        </div>
        <div class="pull-left pl-0 toggle-center toggle-width" v-if="milestonesList !== null">
          <div class="toggle-indicator pull-left mr-5">Milestone view</div>
          <label class="switch pull-left">
            <input type="checkbox" v-model="showDateRangeView" @change="changeMilestoneView($event)" />
            <div class="slider round"></div>
          </label>
          <div class="toggle-indicator pull-left ml-5">Date range view</div>
        </div>
        <div class="text-right float-right pr-20" v-if="!showHideCompliance">
          <span class="pr-35">
            <b v-if="participantData.participantStatus === 'ACTIVEWITHOUTAPP'">
              N/A
            </b>
            <b v-else>{{ participantData.participantCompliancePercentage ? participantData.participantCompliancePercentage : 0 }}%</b>
            Compliance
            <span class="color_blue cursor_pointer" id="complianceInfo">
              <i class="fa fa-info-circle color-grey" aria-hidden="true"></i>
            </span>
            <b-popover placement="bottom" target="complianceInfo" triggers="click blur">
              <template v-slot:content>
                <div class="popover-content">
                  <div class="ml-15" style="color:#000">
                    Compliance is calculated by the number of activities completed by the participant to date divided by the total number of activities available to complete by the participant to date.
                  </div>
                </div>
              </template>
            </b-popover>
          </span>
          <span
            ><b>{{ participantData.participantStudyCompletionPercentage ? participantData.participantStudyCompletionPercentage : 0 }}%</b> Completion</span
          >
        </div>
      </div>
      <div class="participant-current-day" v-if="displayMobileView === true">
        <div class="my-2 text-center">
          <span v-if="triggerDay.currentDayTextVisiblity">
            <span v-if="isParticipantInActive">Participant was {{ participantStatusInLowerCase }} on</span>
            <template v-if="isParticipantActive && shouldNotShowDayZeroMsg()">
              <span>Participant is on</span>
              <span v-if="studyData.screeningMilestoneAllowed">
                <b>
                  Day
                  {{ participantData.participantCurrentDay - studyData.screeningDuration }}</b
                >
              </span>
              <span v-else>
                <b> Day {{ participantData.participantCurrentDay }}</b>
              </span>
            </template>
            <template v-else-if="isParticipantBeingScreened">
              <span>Participant is currently being screened</span>
            </template>
            <span v-if="isParticipantInActive" class="text-primary">
              <b> Day {{ participantData.participantInActiveDay }} </b>
              on
              {{ new Date(participantData.inActiveDate) | dateFormat("MMM DD") }},
              {{ new Date(participantData.inActiveDate) | dateFormat("YYYY") }}
            </span>
            <template v-if="!isParticipantBeingScreened">
              <span class="color-grey pl-10" v-if="triggerDay.triggeredDate">{{ triggerDay.confirmationText }}</span>
              <span class="color-grey" v-if="triggerDay.triggeredDate">{{ new Date(triggerDay.triggeredDate) | formatUTCDate }}</span>
            </template>
          </span>
          <div v-if="triggerDay.triggeredBtnVisiblity" class="pb-25">
            <button class="btn- btn-primary trigger-btn" @click="triggerParticipantDay()">
              Start Study
            </button>
            <span>Click this button to start study activities for this participant.</span>
          </div>
          <div v-if="triggerDay.confirmationText && triggerDay.triggeredDate == null" class="confirmation-text">
            <span v-html="triggerDay.confirmationText" :class="{ 'date-underline': isRescheduleDatePopovershown }"></span>
            <span v-if="triggerDay.editScheduledStartDate" id="popover-edit-scheduled-start-date">
              <img src="/static/img/icon-edit.svg" class="ml-5 icon-edit" style="cursor:pointer; vertical-align: inherit;" />
            </span>
          </div>
        </div>
        <div class="d-flex justify-content-between" v-if="!showHideCompliance">
          <span class="pl-2">
            <b v-if="participantData.participantStatus === 'ACTIVEWITHOUTAPP'">
              N/A
            </b>
            <b v-else>{{ participantData.participantCompliancePercentage ? participantData.participantCompliancePercentage : 0 }}%</b>
            Compliance
            <span class="color_blue cursor_pointer" id="complianceInfo">
              <i class="fa fa-info-circle color-grey" aria-hidden="true"></i>
            </span>
            <b-popover placement="bottom" target="complianceInfo" triggers="click blur">
              <template v-slot:content>
                <div class="popover-content">
                  <div class="ml-15" style="color:#000">
                    Compliance is calculated by the number of activities completed by the participant to date divided by the total number of activities available to complete by the participant to date.
                  </div>
                </div>
              </template>
            </b-popover>
          </span>
          <span class="pr-5"
            ><b>{{ participantData.participantStudyCompletionPercentage ? participantData.participantStudyCompletionPercentage : 0 }}%</b> Completion</span
          >
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="d-inline-block block-height" v-if="displayMobileView === false">
        <div
          class="starting-point"
          :class="{
            started: allProgressPercent > 0,
            inActiveParticiapnt: allProgressPercent <= 4
          }"
        >
          <div class="start" :class="{ inActive: !triggerDay.currentMilestoneVisiblity }"></div>
          <span
            class="year"
            :class="{
              inActive: !triggerDay.currentMilestoneVisiblity,
              inActiveParticiapnt: allProgressPercent <= 4 && isParticipantInActive
            }"
          >
            <span v-if="(isParticipantActive || isParticipantInActive) && triggerDay.dateVisiblity">
              <strong
                >{{ participantData.participant.startDateUtc ? new Date(participantData.participant.startDateUtc) : new Date(participantData.participant.registrationDate) | dateFormat("MMM DD") }},
                {{ participantData.participant.startDateUtc ? new Date(participantData.participant.startDateUtc) : new Date(participantData.participant.registrationDate) | dateFormat("YYYY") }}
              </strong>
            </span>
            <br />
            <span class="max-day"><strong>Day 0</strong></span>
          </span>
        </div>
      </div>
      <div class="milestone-progress" v-if="displayMobileView === false">
        <div class="progress" style="height:3px">
          <div
            class="progress-bar"
            :style="{
              width: `${isParticipantInActive ? redDotNoMilestone : allProgressPercent}%`
            }"
          >
            <span v-if="isParticipantInActive" class="inActiveParticipant" :style="{ left: `${redDotNoMilestone}%` }"></span>
            <div v-if="isParticipantInActive" class="inActiveText" :class="{ inActiveParticiapnt: allProgressPercent <= 4 }" :style="{ left: `${allProgressPercent - 3}%` }"></div>
          </div>
        </div>
      </div>
      <div class="d-inline-block block-height" v-if="displayMobileView === false">
        <div class="ending-point" :class="{ ended: allProgressPercent == 100 }">
          <div class="end"></div>
          <span class="year ml-13 color-shade mt-8">
            <span v-if="(isParticipantActive || isParticipantInActive) && triggerDay.dateVisiblity">
              <strong>
                {{ new Date(participantData.studyEndDate) | dateFormat("MMM DD") }},
                {{ new Date(participantData.studyEndDate) | dateFormat("YYYY") }}
              </strong>
            </span>
            <br />
            <span class="max-day color-shade"
              ><strong>Day {{ participantData.maxDay }}</strong></span
            >
          </span>
        </div>
      </div>
    </div>
    <!-- Progress Bar ends here -->
    <!-- Milestone Carousel Starts Here -->
    <div v-else-if="milestonesList && totalMilestone > 0 && !showDateRangeView" class="milestone-carousel" :class="{ 'no-milestone-carousel': actualMilestones.length <= 0 }">
      <div class="participant-current-day pb-35" v-if="displayMobileView === false">
        <div class="text-left float-left pl-10">
          <span v-if="triggerDay.currentDayTextVisiblity">
            <span v-if="isParticipantInActive">Participant was {{ participantStatusInLowerCase }} on</span>
            <template v-if="isParticipantActive && shouldNotShowDayZeroMsg()">
              <span>Participant is on</span>
              <span v-if="studyData.screeningMilestoneAllowed">
                <a href="javascript:void(0)" @click.prevent="onMilestoneChange(participantData.participantCurrentDay - studyData.screeningDuration, participantData.participantCurrentDay - studyData.screeningDuration)">
                  Day
                  {{ participantData.participantCurrentDay - studyData.screeningDuration }}</a
                >
              </span>
              <span v-else>
                <a href="javascript:void(0)" @click.prevent="onMilestoneChange(participantData.participantCurrentDay, participantData.participantCurrentDay)"> Day {{ participantData.participantCurrentDay }}</a>
              </span>
            </template>
            <template v-else-if="isParticipantBeingScreened">
              <span>Participant is currently being screened</span>
            </template>
            <span v-if="isParticipantInActive">
              <b> Day {{ participantData.participantInActiveDay }} </b>
              on
              {{ new Date(participantData.inActiveDate) | dateFormat("MMM DD") }},
              {{ new Date(participantData.inActiveDate) | dateFormat("YYYY") }}
            </span>

            <template v-if="!isParticipantBeingScreened">
              <span class="color-grey pl-10" v-if="triggerDay.triggeredDate">{{ triggerDay.confirmationText }}</span>
              <span class="color-grey" v-if="triggerDay.triggeredDate">{{ new Date(triggerDay.triggeredDate) | formatUTCDate }}</span>
            </template>
          </span>
          <div v-if="triggerDay.triggeredBtnVisiblity" class="pb-25">
            <button class="btn- btn-primary trigger-btn" @click="triggerParticipantDay()">
              Start Study
            </button>
            <span>Click this button to start study activities for this participant.</span>
          </div>
          <div v-if="triggerDay.confirmationText && triggerDay.triggeredDate == null" class="confirmation-text">
            <span v-html="triggerDay.confirmationText" :class="{ 'date-underline': isRescheduleDatePopovershown }"></span>
            <span v-if="triggerDay.editScheduledStartDate" id="popover-edit-scheduled-start-date">
              <img src="/static/img/icon-edit.svg" class="ml-5 icon-edit" style="cursor:pointer; vertical-align: inherit;" />
            </span>
          </div>
        </div>
        <div class="pull-left pl-0 toggle-center toggle-width">
          <div class="toggle-indicator pull-left mr-5">Milestone view</div>
          <label class="switch pull-left">
            <input type="checkbox" v-model="showDateRangeView" @change="changeMilestoneView($event)" />
            <div class="slider round"></div>
          </label>
          <div class="toggle-indicator pull-left ml-5">Date range view</div>
        </div>
        <div class="text-right float-right pr-20" v-if="!showHideCompliance">
          <span class="pr-35">
            <b v-if="participantData.participantStatus === 'ACTIVEWITHOUTAPP'">
              N/A
            </b>
            <b v-else>{{ participantData.participantCompliancePercentage ? participantData.participantCompliancePercentage : 0 }}%</b>
            Compliance
            <span class="color_blue cursor_pointer" id="complianceInfo">
              <i class="fa fa-info-circle color-grey" aria-hidden="true"></i>
            </span>
            <b-popover placement="bottom" target="complianceInfo" triggers="click blur">
              <template v-slot:content>
                <div class="popover-content">
                  <div class="ml-15" style="color:#000">
                    Compliance is calculated by the number of activities completed by the participant to date divided by the total number of activities available to complete by the participant to date.
                  </div>
                </div>
              </template>
            </b-popover>
          </span>
          <span
            ><b>{{ participantData.participantStudyCompletionPercentage ? participantData.participantStudyCompletionPercentage : 0 }}%</b> Completion</span
          >
        </div>
      </div>
      <div class="participant-current-day" v-if="displayMobileView === true">
        <div class="text-center my-2">
          <span v-if="triggerDay.currentDayTextVisiblity">
            <span v-if="isParticipantInActive">Participant was {{ participantStatusInLowerCase }} on</span>
            <template v-if="isParticipantActive && shouldNotShowDayZeroMsg()">
              <span>Participant is on</span>
              <span v-if="studyData.screeningMilestoneAllowed">
                <b>
                  Day
                  {{ participantData.participantCurrentDay - studyData.screeningDuration }}</b
                >
              </span>
              <span v-else>
                <b> Day {{ participantData.participantCurrentDay }}</b>
              </span>
            </template>
            <template v-else-if="isParticipantBeingScreened">
              <span>Participant is currently being screened</span>
            </template>
            <span v-if="isParticipantInActive" class="text-primary">
              <b> Day {{ participantData.participantInActiveDay }} </b>
              on
              {{ new Date(participantData.inActiveDate) | dateFormat("MMM DD") }},
              {{ new Date(participantData.inActiveDate) | dateFormat("YYYY") }}
            </span>
            <template v-if="!isParticipantBeingScreened">
              <span class="color-grey pl-10" v-if="triggerDay.triggeredDate">{{ triggerDay.confirmationText }}</span>
              <span class="color-grey" v-if="triggerDay.triggeredDate">{{ new Date(triggerDay.triggeredDate) | formatUTCDate }}</span>
            </template>
          </span>
          <div v-if="triggerDay.triggeredBtnVisiblity" class="pb-25">
            <button class="btn- btn-primary trigger-btn" @click="triggerParticipantDay()">
              Start Study
            </button>
            <span>Click this button to start study activities for this participant.</span>
          </div>
          <div v-if="triggerDay.confirmationText && triggerDay.triggeredDate == null" class="confirmation-text">
            <span v-html="triggerDay.confirmationText" :class="{ 'date-underline': isRescheduleDatePopovershown }"></span>
            <span v-if="triggerDay.editScheduledStartDate" id="popover-edit-scheduled-start-date">
              <img src="/static/img/icon-edit.svg" class="ml-5 icon-edit" style="cursor:pointer; vertical-align: inherit;" />
            </span>
          </div>
        </div>
        <div class="d-flex justify-content-between" v-if="!showHideCompliance">
          <span class="pl-2">
            <b v-if="participantData.participantStatus === 'ACTIVEWITHOUTAPP'">
              N/A
            </b>
            <b v-else>{{ participantData.participantCompliancePercentage ? participantData.participantCompliancePercentage : 0 }}%</b>
            Compliance
            <span class="color_blue cursor_pointer" id="complianceInfo">
              <i class="fa fa-info-circle color-grey" aria-hidden="true"></i>
            </span>
            <b-popover placement="bottom" target="complianceInfo" triggers="click blur">
              <template v-slot:content>
                <div class="popover-content">
                  <div class="ml-15" style="color:#000">
                    Compliance is calculated by the number of activities completed by the participant to date divided by the total number of activities available to complete by the participant to date.
                  </div>
                </div>
              </template>
            </b-popover>
          </span>
          <span class="pr-2"
            ><b>{{ participantData.participantStudyCompletionPercentage ? participantData.participantStudyCompletionPercentage : 0 }}%</b> Completion</span
          >
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="slick-slider slick-initialized">
        <button v-if="totalMilestone > 9" @click="moveCarousel(-1)" type="button" class="slick-arrow slick-prev" :class="atHeadOfList ? 'switch-n-bt' : 'switch-b-bt'">
          Previous
        </button>
        <div class="slick-list" v-if="totalMilestone == 3 && milestonesList[1].milestoneDay == 0">
          <div
            class="slick-track"
            :style="{
              width: trackWidth + 'px',
              opacity: 1,
              transform: 'translateX(' + currentOffset + 'px)'
            }"
          >
            <template v-for="(milestone, mileIndex) in milestonesList">
              <div
                v-if="milestone.milestoneName.toLowerCase() != 'start'"
                :key="mileIndex"
                class="slick-slide slick-custom-slide"
                :class="{
                  'active-slide': mileIndex == activeMilestoneIndex,
                  'current-day-milestone': milestone.milestoneSelected,
                  'milestone-completed': mileIndex <= currentMilestoneIndex
                }"
              >
                <div
                  class="slick-custom"
                  :class="{
                    activeMilestone: mileIndex == activeMilestoneIndex,
                    stepsCompleted: triggerDay.currentMilestoneVisiblity && mileIndex <= currentMilestoneIndex && !milestone.skippedMilestone,
                    stepsMissed: milestone.skippedMilestone,
                    milestone: actualMilestones.length > 0,
                    'no-milestone': actualMilestones.length <= 0
                  }"
                  @click="
                    showMilestoneDetail(milestone, mileIndex);
                    activeMilestoneIndex = mileIndex;
                  "
                  :style="{ width: singleMileStoneWidth + 'px' }"
                >
                  <div
                    :class="{
                      disqualifiedWithdrawn: isParticipantInActive && mileIndex === currentMilestoneIndex
                    }"
                    :style="{
                      transform: 'translateX(' + redDotPosition + 'px)'
                    }"
                  ></div>
                  <div class="name">{{ milestone.milestoneName }}</div>
                  <div class="day" v-if="milestone.milestoneDay != undefined">Day {{ milestone.milestoneDay }}</div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="slick-list" v-else>
          <div
            class="slick-track"
            :style="{
              width: trackWidth + 'px',
              opacity: 1,
              transform: 'translateX(' + currentOffset + 'px)'
            }"
          >
            <div
              v-for="(milestone, mileIndex) in milestonesList"
              :key="mileIndex"
              class="slick-slide"
              :class="{
                'active-slide': mileIndex == activeMilestoneIndex,
                'current-day-milestone': milestone.milestoneSelected,
                'milestone-completed': mileIndex <= currentMilestoneIndex
              }"
            >
              <div
                :class="{
                  activeMilestone: mileIndex == activeMilestoneIndex,
                  stepsCompleted: triggerDay.currentMilestoneVisiblity && mileIndex <= currentMilestoneIndex && !milestone.skippedMilestone,
                  stepsMissed: milestone.skippedMilestone,
                  milestone: actualMilestones.length > 0,
                  'no-milestone': actualMilestones.length <= 0
                }"
                @click="
                  showMilestoneDetail(milestone, mileIndex);
                  activeMilestoneIndex = mileIndex;
                "
                :style="{ width: singleMileStoneWidth + 'px' }"
              >
                <div
                  :class="{
                    disqualifiedWithdrawn: isParticipantInActive && mileIndex === currentMilestoneIndex
                  }"
                  :style="{ transform: 'translateX(' + redDotPosition + 'px)' }"
                ></div>
                <div class="name">{{ milestone.milestoneName }}</div>
                <div class="day" v-if="milestone.milestoneDay != undefined">Day {{ milestone.milestoneDay }}</div>
                <div
                  class="percent"
                  :class="{
                    green: milestone.completionPercentage >= 95,
                    red: milestone.completionPercentage < 95
                  }"
                  v-if="milestone.completionPercentage != undefined"
                >
                  {{ milestone.completionPercentage }}%
                </div>
              </div>
            </div>
          </div>
        </div>
        <button v-if="totalMilestone > 9" @click="moveCarousel(1)" type="button" class="slick-arrow slick-next" :class="atHeadOfList ? 'switch-b-bt' : 'switch-n-bt'">
          Next
        </button>
      </div>
    </div>
    <!-- Milestone Carousel Ends Here -->

    <ParticipantConsentModal :showConsentModal="consentModalStatus" @cancelButtonClicked="consentModalStatus = false" @triggerDayZeroPopup="triggerDayZeroPopup" />
    <ParticipantTriggerDayZeroModal :triggeredParticipant="participantData.participant" @resetParticipantDayZeroStatus="resetParticipantDayZeroStatus" :showModal="modalStatus" :studyId="participantData.studyId" :piId="participantData.piId" :modalText="modalText" @toggleScheduleModal="toggleScheduleModal" :isScheduledStart="isScheduledStart"></ParticipantTriggerDayZeroModal>
    <ScheduleStudyStartModal :participantId="participantData.participant.id" :piId="participantData.piId" :showModal="isScheduleStartModalShown" :participantDetails="participantDetails" @toggleScheduleModal="toggleScheduleModal" @studyStartScheduled="studyStartScheduled"></ScheduleStudyStartModal>
    <EditScheduleStudyStartPopover v-if="triggerDay.editScheduledStartDate" :scheduledStartDate="triggerDay.editScheduledStartDate" :participantId="participantData.participant.id" :piId="participantData.piId" :participantDetails="participantDetails" @studyStartScheduled="studyStartScheduled" @rescheduleDatePopoverShown="rescheduleDatePopoverShown" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import _ from "lodash";
import ParticipantTriggerDayZeroModal from "@/components/participants/participant-trigger-day-zero-modal";
import ParticipantConsentModal from "@/components/participants/participant-consent-modal";
import ScheduleStudyStartModal from "@/components/participants/schedule-study-start-modal";
import { participantStatusesText } from "@/constants/authRoles";
import EditScheduleStudyStartPopover from "@/components/participants/edit-schedule-start-date";
import * as constant from "../../constants/config";

export default {
  name: "study-participant-milestone-carousel-progress",
  components: {
    ParticipantTriggerDayZeroModal,
    ScheduleStudyStartModal,
    EditScheduleStudyStartPopover,
    ParticipantConsentModal
  },
  props: {
    participantData: {
      type: Object,
      required: true,
      default: () => null
    },
    milestonesList: {},
    selectedMilestone: {
      default: () => null
    },
    participantDetails: {
      type: Object
    },
    istelehealthCallInitiated: {
      type: Boolean
    },
    triggerDay: {
      type: Object,
      default: () => {}
    },
    outsideClickStatus: {
      type: Boolean,
      default: false
    },
    isScheduledStart: {
      type: Boolean,
      default: false
    },
    showHideCompliance: {
      type: Boolean
    },
    studyData: {
      type: Object
    }
  },
  data() {
    return {
      actualMilestones: [],
      consentModalStatus: false,
      activeMilestoneIndex: null,
      currentMilestoneIndex: null,
      slidesToScroll: 4,
      currentOffset: 0,
      windowSize: 9,
      trackWidth: null,
      singleMileStoneWidth: null,
      paginationFactor: null,

      oneSlideWidth: null,
      totalMilestone: null,
      milestonesLeft: null,
      afterWindowWidth: null,
      oddItems: null,
      modalStatus: false,
      modalText: {
        heading: "Are you sure you want to start the study for this participant?",
        description: this.isScheduledStart ? "Confirm by selecting a start date below. The study activities will be available to the participant as soon as they can confirm this request." : "Clicking Yes will make study activities available to the participant as soon as they confirm this request.",
        cancelBtnCss: { backgroundColor: "#e0e0e0", color: "#000000" }
      },
      customizeMilestone: { milestoneName: "Today", key: "today" },
      participantStatusesText,
      isScheduleStartModalShown: false,
      isRescheduleDatePopovershown: false,
      displayMobileView: Boolean,
      showDateRangeView: false
    };
  },
  computed: {
    redDotNoMilestone() {
      if (this.participantData.participantInActiveDay !== 0) {
        return (this.participantData.participantInActiveDay / this.participantData.maxDay) * 100;
      }
      if (this.participantData.participantInActiveDay === 0) {
        return 0.2;
      }
      return 0;
    },
    redDotPosition() {
      if (this.currentMilestoneIndex != null) {
        const inActiveDay = this.participantData.participantInActiveDay;
        const currentMilestone = this.actualMilestones && this.actualMilestones[this.currentMilestoneIndex].milestoneDay;
        const nextMilestone = (this.actualMilestones && this.currentMilestoneIndex < this.actualMilestones.length - 1 && this.actualMilestones[this.currentMilestoneIndex + 1].milestoneDay) || currentMilestone + 1;
        const pixelPerDay = this.singleMileStoneWidth / (nextMilestone - currentMilestone);

        let RedDotPosition;

        // If there is only single milestone in a study
        if (this.actualMilestones.length === 3 && !this.actualMilestones[0].milestoneId) {
          const singleDayInPxFromStartDay = this.singleMileStoneWidth / (this.actualMilestones[1].milestoneDay - this.actualMilestones[0].startDay);
          const singleDayInPxTillEndDay = this.singleMileStoneWidth / (this.participantData.maxDay - this.actualMilestones[1].milestoneDay);
          const positionForRedDotInSingleMilestone = singleDayInPxFromStartDay * inActiveDay;

          if (inActiveDay === 0 && inActiveDay !== this.actualMilestones[1].milestoneDay) {
            RedDotPosition = 1 - this.singleMileStoneWidth;
          } else if (inActiveDay === 0 && inActiveDay === this.actualMilestones[1].milestoneDay) {
            RedDotPosition = 1;
          } else if (inActiveDay < this.actualMilestones[1].milestoneDay) {
            RedDotPosition = positionForRedDotInSingleMilestone - this.singleMileStoneWidth;
          } else {
            RedDotPosition = singleDayInPxTillEndDay * (inActiveDay - this.actualMilestones[1].milestoneDay);
          }
        } else if (this.currentMilestoneIndex >= 0 && this.currentMilestoneIndex < this.actualMilestones.length && inActiveDay !== currentMilestone) {
          // RedDotPosition = prevMilesTotal + (pixelPerDay * (inActiveDay-currentMilestone));
          RedDotPosition = pixelPerDay * Math.abs(inActiveDay - currentMilestone);
        } else if (inActiveDay === currentMilestone) {
          RedDotPosition = this.singleMileStoneWidth / 95;
        }
        return RedDotPosition;
      }

      return this.singleMileStoneWidth / 95;
    },
    atHeadOfList() {
      return this.currentOffset === 0;
    },
    allProgressPercent() {
      if (this.participantData.fakeParticipantCurrentDay == null) {
        if ((this.participantData.participantCurrentDay / this.participantData.maxDay) * 100 <= 4 && this.isParticipantInActive) {
          return 4;
        }
        return (this.participantData.participantCurrentDay / this.participantData.maxDay) * 100;
      }
      if ((this.participantData.fakeParticipantCurrentDay / this.participantData.maxDay) * 100 <= 4 && this.isParticipantInActive) {
        return 4;
      }
      return (this.participantData.fakeParticipantCurrentDay / this.participantData.maxDay) * 100;
    },
    calculatePopoverPosition() {
      const defaultPosition = 10;
      const progressBarWidth = this.allProgressPercent;
      return progressBarWidth - defaultPosition;
    },
    participantStatusInLowerCase() {
      const currentStatus = this.participantStatusesText[this.participantData.participantStatus].toLowerCase();
      if (currentStatus === "disqualified" || currentStatus === "withdrawn") {
        return "discontinued";
      }
      return this.participantStatusesText[this.participantData.participantStatus].toLowerCase();
    },
    isParticipantInActive() {
      return this.participantData.participantStatus == "DISQUALIFIED" || this.participantData.participantStatus == "WITHDRAWSTUDY" || this.participantData.participantStatus == "DISCONTINUED";
    },
    isParticipantActive() {
      return this.participantData.participantStatus == "VERIFIED" || this.participantData.participantStatus == "REGISTERED" || this.participantData.participantStatus == "ACTIVE" || this.participantData.participantStatus == "ACTIVEWITHOUTAPP" || this.participantData.participantStatus == "ACTIVEWMODIFICATION";
    },
    isParticipantBeingScreened() {
      return this.participantData.participantStatus == "SCREENING";
    }
  },
  created() {
    if (constant.SCREENWIDTH > 1200) {
      this.displayMobileView = false;
    } else {
      this.displayMobileView = true;
    }
  },
  watch: {
    outsideClickStatus(v) {
      if (v) {
        //this.modalStatus = false;
      }
    },
    milestonesList(v) {
      v != null ? this.initCarousel() : "";
    },
    istelehealthCallInitiated() {
      this.milestonesList ? this.initCarousel() : "";
      this.actualMilestones = this.participantData.participantMileStoneList;
    },
    selectedMilestone(v) {
      this.activeMilestoneIndex = v;
      if (this.activeMilestoneIndex == v && this.totalMilestone <= this.windowSize) {
        return;
      }
      //This code is going to execute when the milestone value get changed fromt the milestone drop down
      //So we need to make the selected milestone active in the carousel.
      //Slide the carousel if needed
      if (v >= this.windowSize && this.currentOffset == 0) {
        this.initialCurrentOffset(this.activeMilestoneIndex);
      } else if (this.currentOffset != 0 && v >= this.windowSize) {
        this.moveCarousel(1);
      } else {
        this.moveCarousel(-1);
      }
    }
  },
  methods: {
    ...mapActions(["setDateRangeView"]),
    changeMilestoneView(e) {
      this.setDateRangeView(e.target.checked);
      this.showDateRangeView = e.target.checked;
    },
    moveCarousel(direction) {
      if (direction === 1) {
        if (this.milestonesLeft < this.slidesToScroll) {
          //Last Slide
          this.currentOffset -= this.singleMileStoneWidth * this.milestonesLeft;
        } else if (this.afterWindowWidth + this.currentOffset >= this.paginationFactor) {
          this.currentOffset -= this.oneSlideWidth;
        } else {
          this.currentOffset -= this.singleMileStoneWidth * this.oddItems;
        }
      } else if (direction === -1) {
        if (this.milestonesLeft < this.slidesToScroll) {
          this.currentOffset = 0;
        } else if (this.currentOffset * -1 > this.paginationFactor) {
          this.currentOffset += this.paginationFactor;
        } else {
          this.currentOffset = 0;
        }
      }
    },
    shouldNotShowDayZeroMsg() {
      //This is implemented for TPD studies
      return !(this.studyData.isManualStudyStart && this.participantData.participant.status == "VERIFIED" && this.participantData.participant.participantStudyStartTrigger.triggeredBy == null);
    },
    initCarousel() {
      this.resetCarouselProperties();

      this.totalMilestone = this.milestonesList.length;
      const pw = this.$parent.$refs.profile.offsetWidth - 20; //Width of the section in which carousel & other informations are displaying.
      this.singleMileStoneWidth = Math.ceil(pw / this.windowSize);
      this.trackWidth = this.singleMileStoneWidth * this.totalMilestone;
      const doubleSingleMileStoneWidth = this.singleMileStoneWidth * 2;
      if (this.totalMilestone < this.windowSize && this.trackWidth + doubleSingleMileStoneWidth < pw) {
        this.singleMileStoneWidth = Math.ceil(pw / this.totalMilestone);
        this.trackWidth = pw + this.totalMilestone;
      }

      this.paginationFactor = this.singleMileStoneWidth * this.slidesToScroll;

      //Calculations Need for Previous and Next handler
      this.oneSlideWidth = this.singleMileStoneWidth * this.slidesToScroll;
      this.milestonesLeft = this.totalMilestone - this.windowSize;
      const widthWindow = this.singleMileStoneWidth * this.windowSize;
      this.afterWindowWidth = this.trackWidth - widthWindow;
      //Find out are there any odd items

      this.oddItems = (this.totalMilestone - this.windowSize) % this.slidesToScroll;

      //Get the index of the current day milestones to default the carousel to that milestone
      const currentDayIndex = _.findIndex(this.milestonesList, "milestoneSelected");
      if (currentDayIndex >= 0) {
        this.activeMilestoneIndex = currentDayIndex;
        this.currentMilestoneIndex = currentDayIndex;
        this.initialCurrentOffset(this.currentMilestoneIndex);
        this.$emit("checkNResetCarouselSelectedIndex");
      }
    },
    showMilestoneDetail(milestone, mileIndex) {
      if (this.studyData.screeningMilestoneAllowed && this.participantData.participant.status == "SCREENING") {
        const isScreeningMilestone = this.studyData.milestonesList.filter(milestoneData => milestoneData.milestoneId == milestone.milestoneId).map(milestoneData => milestoneData.milestoneType);
        if (!isScreeningMilestone[0]) {
          this.$toastr.error("Cannot open study milestones tasks as participant is in screening phase.");
          return;
        }
      }
      if (this.activeMilestoneIndex == mileIndex) {
        return;
      }
      let isUserClickOnStartOrEndDay = false;
      //Since carousel milestone is clicked change the view to milestone
      const actualMilestoneLength = this.actualMilestones.length;

      if (actualMilestoneLength > 0) {
        if (milestone.milestoneName.toLowerCase() == "start" || milestone.milestoneName.toLowerCase() == "end") {
          isUserClickOnStartOrEndDay = true;
        }
      }

      let startDay = null;
      let endDay = null;
      const milestoneIndex = actualMilestoneLength == 1 ? 0 : mileIndex;

      if (milestone.startDay != undefined && milestone.endDay != undefined) {
        startDay = milestone.startDay;
        endDay = milestone.endDay;
      } else {
        //This code means user has clicked on the Start or End, we need to display the all milestone details.
        startDay = this.milestonesList[1].startDay;
        endDay = this.milestonesList[1].endDay;
      }
      this.$emit("getMilestoneDetails", startDay, endDay, milestoneIndex, isUserClickOnStartOrEndDay, milestone);
    },
    onMilestoneChange(startDay, endDay, isCustom) {
      this.$emit("onMilestoneChange", startDay, endDay, isCustom);
    },
    resetCarouselProperties() {
      this.activeMilestoneIndex = null;
      this.currentMilestoneIndex = null;
      this.currentOffset = 0;
      this.trackWidth = null;
      this.singleMileStoneWidth = null;
      this.paginationFactor = null;
      this.oneSlideWidth = null;
      this.totalMilestone = null;
      this.milestonesLeft = null;
      this.afterWindowWidth = null;
      this.oddItems = null;
    },
    initialCurrentOffset(dayIndex) {
      if (dayIndex >= this.windowSize) {
        const currentDay = dayIndex + 1;
        const findSlideNo = Math.ceil((currentDay - this.windowSize) / this.slidesToScroll);
        const leftTransform = findSlideNo * this.oneSlideWidth;
        if (leftTransform < this.afterWindowWidth) {
          this.currentOffset = leftTransform * -1;
        } else {
          this.currentOffset = this.afterWindowWidth * -1;
        }
      }
    },
    resetParticipantDayZeroStatus(dayZeroStatus) {
      if (!dayZeroStatus) {
        this.modalStatus = false;
        return;
      }
      this.modalStatus = false;
      this.$emit("resetParticipant");
    },
    triggerParticipantDay() {
      if (this.participantDetails && this.participantDetails.afterRegistrationConsentEnabled && !this.participantDetails.latestConsentedOn) {
        this.consentModalStatus = true;
      } else {
        this.modalStatus = true;
      }
    },
    triggerDayZeroPopup() {
      this.modalStatus = true;
    },
    toggleScheduleModal(value) {
      this.isScheduleStartModalShown = value;
      this.modalStatus = false;
    },
    studyStartScheduled(scheduledStart, scheduledDateMoment) {
      this.$emit("resetParticipant", scheduledStart, scheduledDateMoment);
    },
    rescheduleDatePopoverShown(shown) {
      this.isRescheduleDatePopovershown = shown;
    }
  },
  mounted() {
    this.milestonesList ? this.initCarousel() : "";
    this.actualMilestones = this.participantData.participantMileStoneList;
    this.showDateRangeView = this.$store.getters.getDateRangeView;
  }
};
</script>
<style scoped lang="scss" src="@/assets/participant-profile-milestone-carousel.scss" />
<style lang="scss">
.confirmation-text {
  .scheduled-date {
    font-family: Roboto-Bold !important;
    color: #666669;
  }
  .date-underline {
    .scheduled-date {
      text-decoration: underline;
    }
  }
}
.slick-slide.slick-custom-slide {
  width: 33% !important;
}
.toggle-indicator {
  opacity: 0.8;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #666669;
}
.switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 23px;
  margin-top: -1px;
}
/* Hide default HTML checkbox */
.switch input {
  display: none;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px solid #ccc;
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 1px;
  background-color: #ccc;
}
input:checked + .slider {
  border: 2px solid #48bf7a;
}
input:checked + .slider:before {
  content: "";
  background-color: #48bf7a;
}
input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}
input:checked + .slider:before {
  /*content: '✓';*/
  position: absolute;
  color: #2ecc71;
  text-align: center;
  font-size: 20px;
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.toggle-center {
  justify-content: center;
  display: flex;
}
.toggle-width {
  width: 55%;
}
.toggle-width-p {
  width: 25%;
}
.switch-n-bt {
  display: none !important;
}
.switch-b-bt {
  display: block !important;
}
</style>
